/* 26.09.2026: переклад через Translate & Adapt. ADL("текст") повертає переклад
   з window.ADAPTIS_L (snippets/adaptis-l.liquid, ключі locales/uk.json
   adaptis_js.*), а без перекладу той самий український текст. */
var ADL = window.ADL || (window.ADL = function(s){ return window.ADAPTIS_L ? window.ADAPTIS_L(s) : s; });
/* Кошик Adaptis: кількість, видалення і примітка без перезавантаження сторінки.
   22.09.2026. Розмітка в sections/main-cart.liquid, стилі там же і в
   adaptis-configurator.css (токени й кнопки). */
(function(){
"use strict";
const root = document.getElementById("adaptisCart");
if (!root) return;
const sectionId = root.dataset.sectionId;
const cartRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
let busy = false;

function announce(c){
  document.dispatchEvent(new CustomEvent("cart:update", {bubbles:true, detail:{
    resource:c, sourceId:"adaptis-cart", data:{itemCount:c.item_count, source:"adaptis-cart"}
  }}));
}
/* Перемальовуємо секцію відповіддю Shopify: розмітка одна й та сама, тому
   після зміни кількості сторінка не перезавантажується. */
function applyHtml(html){
  const doc = new DOMParser().parseFromString(html || "", "text/html");
  const next = doc.getElementById("adaptisCart");
  /* Клас теж переносимо: порожній кошик має свій вигляд (ac--empty). */
  if (next){ root.innerHTML = next.innerHTML; root.className = next.className; }
  keepOrder();
  watchBar();
  enhance();
  return !!next;
}
function repaint(){
  return fetch(location.pathname + "?section_id=" + sectionId, {headers:{Accept:"text/html"}})
    .then(r => r.text())
    .then(applyHtml);
}
/* 26.09.2026: порядок позицій не стрибає. Shopify не вміє міняти варіант у
   позиції, тому перемикач «Ціна для Сил Оборони» додає пару й прибирає
   старий варіант, а нова позиція в Shopify стає першою. Запамʼятовуємо
   порядок, який бачив покупець (ключі позицій), і розставляємо рядки за ним.
   Нові товари, як і раніше, зверху. Пам'ять лише в цьому браузері; якщо її
   немає, порядок той, що віддав Shopify. */
const ORDER_KEY = "adaptis-cart-order";
function readOrder(){ try { return JSON.parse(localStorage.getItem(ORDER_KEY) || "[]"); } catch (e) { return []; } }
function saveOrder(a){ try { localStorage.setItem(ORDER_KEY, JSON.stringify(a)); } catch (e) {} }
function keepOrder(){
  const group = root.querySelector(".ac__group");
  if (!group) { saveOrder([]); return; }
  const rows = [...group.querySelectorAll(":scope > .ac__row[data-key]")];
  const old = readOrder();
  const pos = k => old.indexOf(k);
  const fresh = rows.filter(r => pos(r.dataset.key) < 0);
  const known = rows.filter(r => pos(r.dataset.key) > -1).sort((a, b) => pos(a.dataset.key) - pos(b.dataset.key));
  const want = fresh.concat(known);
  if (want.some((r, i) => r !== rows[i])) want.forEach(r => group.appendChild(r));
  saveOrder(want.map(r => r.dataset.key));
}
/* Позиція замінена парою: нова стає на місце старої. */
function swapOrder(pairs){
  const a = readOrder();
  pairs.forEach(p => { const i = a.indexOf(p[0]); if (i > -1) a[i] = p[1]; });
  saveOrder(a);
}
/* 26.09.2026: нижня панель «Оформити замовлення» на телефоні. Видна, поки
   кнопки в підсумку і підвалу не видно; клас на html піднімає Binotel. */
let barIO = null;
function watchBar(){
  if (barIO) barIO.disconnect();
  const bar = root.querySelector("[data-ac-bar]"), go = root.querySelector(".ac__go");
  const foot = document.querySelector("footer, .shopify-section-group-footer-group");
  const set = on => {
    if (!bar) { document.documentElement.classList.remove("ac-bar-on"); return; }
    bar.classList.toggle("is-on", on);
    bar.setAttribute("aria-hidden", String(!on));
    const b = bar.querySelector("button");
    if (b) b.tabIndex = on ? 0 : -1;
    document.documentElement.classList.toggle("ac-bar-on", on);
  };
  if (!bar || !go || !("IntersectionObserver" in window)){ set(false); return; }
  const seen = new Map();
  barIO = new IntersectionObserver(es => {
    es.forEach(e => seen.set(e.target, e.isIntersecting));
    set(![...seen.values()].some(Boolean));
  });
  barIO.observe(go);
  if (foot) barIO.observe(foot);
}
keepOrder();
watchBar();
function change(key, qty){
  if (busy) return;
  busy = true;
  root.classList.add("is-busy");
  fetch(cartRoot() + "cart/change.js", {
    method:"POST",
    headers:{"Content-Type":"application/json", Accept:"application/json"},
    body:JSON.stringify({id:key, quantity:qty})
  })
    .then(r => r.json())
    .then(c => { announce(c); return repaint(); })
    .catch(() => location.reload())
    .then(() => { busy = false; root.classList.remove("is-busy"); fixMin(); });
}
root.addEventListener("click", e => {
  const b = e.target.closest("[data-cq]");
  if (!b) return;
  e.preventDefault();
  const d = +b.dataset.cq;
  const row = b.closest(".ac__row");
  const now = parseInt(row.querySelector(".qty span").textContent, 10) || 1;
  /* 24.09.2026: підписка мінімум на 3 місяці (data-min рядка). Нижче «−» не
     опускає, прибрати позицію можна кнопкою «Прибрати». */
  const min = parseInt(row.dataset.min, 10) || 1;
  if (d < 0 && min > 1 && now + d < min) return;
  change(b.dataset.key, d === 0 ? 0 : Math.max(0, now + d));
});
/* Якщо підписка потрапила в кошик із меншою кількістю (наприклад, зі сторінки
   тарифу), піднімаємо її до мінімуму один раз при відкритті кошика. */
const minTried = new Set();
function fixMin(){
  if (busy) return;
  const row = [...root.querySelectorAll(".ac__row[data-min]")].find(r => {
    if (minTried.has(r.dataset.key)) return false;
    const min = parseInt(r.dataset.min, 10) || 1;
    const q = parseInt((r.querySelector(".qty span") || {}).textContent, 10) || 0;
    return min > 1 && q > 0 && q < min;
  });
  if (row){ minTried.add(row.dataset.key); change(row.dataset.key, parseInt(row.dataset.min, 10)); }
}
fixMin();
/* 24.09.2026: перемикач «Ціна для Сил Оборони» в товарі. Позицію, що
   має варіант-пару з протилежним «Призначенням» (data-pair у рядку), міняємо
   на цю пару з тією ж кількістю й властивостями. Властивість «Призначення»,
   якщо є, оновлюємо.
   26.09.2026: швидше. Раніше чотири запити підряд (кошик, додати, прибрати,
   перемалювати) і кошик тьмяний 1,7-2 с. Тепер ціна в рядку і «Разом»
   міняються одразу, а Shopify отримує один запит (позиція без властивостей:
   update.js з новим варіантом і старим ключем) або два (з властивостями:
   add.js, потім update.js). Нову розмітку кошика Shopify віддає у відповіді
   (sections), окремого перемальовування немає. */
const fmt = c => (c / 100).toLocaleString("uk-UA").replace(/[\s,]/g, " ") + " ₴";
function showPair(row, qty){
  const oldLine = +row.dataset.price || 0, newLine = (+row.dataset.pairprice || 0) * qty;
  if (!newLine) return;
  const b = row.querySelector(".ac__price b");
  if (b) b.textContent = fmt(newLine);
  const was = row.querySelector(".ac__was");
  if (was) was.remove();
  const tot = root.querySelector(".ac__srow--total b");
  const cur = tot ? parseInt(tot.textContent.replace(/\D/g, ""), 10) * 100 : 0;
  if (tot && cur) tot.textContent = fmt(cur - oldLine + newLine);
}
/* 26.09.2026: перемикач однаковий для всього кошика (власник): вмикаємо чи
   вимикаємо ціну для Сил Оборони в одній позиції, і вона міняється в усіх
   позиціях, що мають таку пару. Позиції без властивостей міняються одним
   update.js, з властивостями спершу add.js (властивості переносяться). */
root.addEventListener("change", e => {
  const t = e.target.closest("[data-def-line]");
  if (!t) return;
  if (busy){ t.checked = !t.checked; return; }
  const want = t.checked;
  const rows = [...root.querySelectorAll(".ac__row[data-pair]")].filter(r => (r.dataset.def === "true") !== want);
  if (!rows.length) return;
  busy = true;
  const json = {"Content-Type":"application/json", Accept:"application/json"};
  const post = (u, body) => fetch(cartRoot() + u, {method:"POST", headers:json, body:JSON.stringify(body)})
    .then(r => { if (!r.ok) throw new Error(u); return r.json(); });
  const sec = {sections:[sectionId], sections_url:location.pathname};
  const all = [...root.querySelectorAll(".ac__row[data-variant]")];
  const plain = [], rich = [];
  rows.forEach(row => {
    const pair = +row.dataset.pair, qty = +row.dataset.qty || 1;
    let props = {};
    /* Liquid віддає властивості масивом пар [[назва, значення], ...]. */
    try { props = JSON.parse(row.dataset.props || "{}") || {}; } catch (err) { props = {}; }
    if (Array.isArray(props)) props = Object.fromEntries(props.filter(x => Array.isArray(x) && x.length === 2));
    if ("Призначення" in props && row.dataset.pairp) props["Призначення"] = row.dataset.pairp;
    /* Той самий варіант уже є іншою позицією: update.js за ID варіанта змінив би її кількість. */
    const dup = all.some(r => r !== row && +r.dataset.variant === pair) || plain.some(p => p.pair === pair);
    const x = {row, key:row.dataset.key, pair, qty, props};
    (!Object.keys(props).length && !dup ? plain : rich).push(x);
    showPair(row, qty);
    const cb = row.querySelector("[data-def-line]");
    if (cb) cb.checked = want;
  });
  const updates = {};
  plain.forEach(x => { updates[x.pair] = x.qty; updates[x.key] = 0; });
  rich.forEach(x => { updates[x.key] = 0; });
  const first = rich.length
    ? post("cart/add.js", {items:rich.map(x => ({id:x.pair, quantity:x.qty, properties:x.props}))}).then(added => {
        const got = (added && added.items) || [];
        swapOrder(rich.map((x, i) => [x.key, got[i] && got[i].key]).filter(p => p[1]));
      })
    : Promise.resolve();
  first
    .then(() => post("cart/update.js", Object.assign({updates}, sec)))
    .then(c => {
      const used = new Set();
      swapOrder(plain.map(x => {
        const it = (c.items || []).find(i => i.variant_id === x.pair && !used.has(i.key));
        if (it) used.add(it.key);
        return [x.key, it && it.key];
      }).filter(p => p[1]));
      announce(c);
      const h = c.sections && c.sections[sectionId];
      return h && applyHtml(h) ? null : repaint();
    })
    .catch(() => location.reload())
    .then(() => { busy = false; });
});
/* 26.09.2026: одна цінова категорія на весь кошик (правило власника). Якщо
   товари додавались окремо і частина з ціною для Сил Оборони, а частина ні,
   при відкритті кошика решта переходить на ціну для Сил Оборони тим самим
   перемикачем (подія change на увімкненому). */
(function(){
  const on = root.querySelector(".ac__row[data-pair][data-def=\"true\"] [data-def-line]");
  if (on && root.querySelector(".ac__row[data-pair][data-def=\"false\"]")) on.dispatchEvent(new Event("change", {bubbles:true}));
})();
/* 26.09.2026: «Скопіювати посилання на кошик». Обробник випадково зник 26.09
   (разом з правкою «Очистити кошик»), кнопка нічого не робила; повернуто з
   бекапу -26-q. Посилання: /cart/<варіант>:<кількість>,…, властивості позицій
   атрибутом для менеджера. */
function cartLink(c){
  if (!c.items.length) return null;
  const qty = {}, order = [];
  c.items.forEach(i => { if (!(i.variant_id in qty)) order.push(i.variant_id); qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
  const q = new URLSearchParams();
  q.set("storefront", "true");
  const props = c.items.map(i => {
    const p = Object.keys(i.properties || {}).filter(k => k[0] !== "_" && i.properties[k]).map(k => k + ": " + i.properties[k]);
    return p.length ? i.product_title + " (" + p.join(", ") + ")" : "";
  }).filter(Boolean);
  if (props.length) q.set("attributes[Властивості позицій]", props.join("; "));
  return location.origin + cartRoot() + "cart/" + order.map(id => id + ":" + qty[id]).join(",") + "?" + q.toString();
}
function copyText(text){
  if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text).then(() => true, () => fallbackCopy(text));
  return Promise.resolve(fallbackCopy(text));
}
function fallbackCopy(text){
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.cssText = "position:fixed;top:-1000px;opacity:0";
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try { ok = document.execCommand("copy"); } catch (e) { ok = false; }
  ta.remove();
  if (!ok){ try { window.prompt(ADL("Скопіюйте посилання"), text); ok = true; } catch (e) {} }
  return ok;
}
root.addEventListener("click", e => {
  const b = e.target.closest("[data-copy-cart]");
  if (!b) return;
  e.preventDefault();
  const t = b.querySelector("span") || b, svg = b.querySelector("svg");
  const label = t.textContent, icon0 = svg ? svg.innerHTML : "";
  fetch(cartRoot() + "cart.js", {headers:{Accept:"application/json"}})
    .then(r => r.json())
    .then(c => { const url = cartLink(c); return url ? copyText(url) : false; })
    .then(ok => {
      /* Поки «Посилання скопійовано», замість іконки посилання галочка. */
      t.textContent = ok ? ADL("Посилання скопійовано") : ADL("Не вдалося скопіювати");
      b.classList.toggle("is-done", !!ok);
      if (ok && svg) svg.innerHTML = '<path d="M5 12.5L10 17.5L19 7.5"/>';
      setTimeout(() => { t.textContent = label; b.classList.remove("is-done"); if (svg) svg.innerHTML = icon0; }, 1800);
    })
    .catch(() => {});
});
/* «Очистити кошик»: підтвердження, очищення позицій, атрибутів і примітки.
   26.09.2026: обробник на всьому кошику. Раніше він висів на самій кнопці, а
   після будь-якої зміни (кількість, «Прибрати», ціна для Сил Оборони)
   розмітка кошика замінюється, і нова кнопка лишалась без обробника. */
root.addEventListener("click", e => {
  const b = e.target.closest("[data-clear-cart]");
  if (!b) return;
  e.preventDefault();
  if (busy || !window.confirm(ADL("Очистити кошик?"))) return;
  busy = true;
  b.disabled = true;
  const json = {"Content-Type":"application/json", Accept:"application/json"};
  fetch(cartRoot() + "cart.js", {headers:json}).then(r => r.json()).then(c => {
    const attrs = {};
    Object.keys(c.attributes || {}).forEach(k => { attrs[k] = ""; });
    return fetch(cartRoot() + "cart/clear.js", {method:"POST", headers:json}).then(() =>
      fetch(cartRoot() + "cart/update.js", {method:"POST", headers:json, body:JSON.stringify({attributes:attrs, note:""})}));
  }).then(() => { saveOrder([]); location.reload(); }, () => location.reload());
});
/* 24.09.2026: примітки до замовлення в кошику немає, коментар клієнт пише в
   чекауті. Примітку, що лишилась у кошику раніше, стираємо, інакше вона
   потрапила б у замовлення непомітно для покупця. */
if (root.dataset.note === "1"){
  fetch(cartRoot() + "cart/update.js", {
    method:"POST",
    headers:{"Content-Type":"application/json", Accept:"application/json"},
    body:JSON.stringify({note:""})
  }).catch(() => {});
}

/* ============================================================================================
   09.10.2026 (власник): кошик пояснює, навіщо кожна позиція, дає змінити колір корпусу Adaptis
   і радить, що ще взяти. Усе малюється поверх розмітки Shopify після кожного перемальовування
   (enhance), сама розмітка рядків не змінена.
   ============================================================================================ */
const HN = {
  mini:"starlink-mini", miniX:"starlink-mini-x", amuletT:"starlink-adaptis-amulet", amuletS:"service-adaptis-amulet-starlink",
  miniKit:"adaptis-minikit-for-starlink-mini", g3kit:"products-gen3-main-unit-rev4", g2kit:"adaptis-g2kit-starlink-gen2",
  hp:"adaptis-hp-for-starlink-high-performance",
  psu:"starlink-mini-adapter-12-24v", cc160:"adaptis-gp-cc160-160w-2-type-c-usb", ccSet:"adaptis-car-charger-5m-dc-typec-cable",
  dc:"cable-dc-type-c-5m", eth:"starlink-gen3-cable",
  p2fit:"powerbank-adaptis-p2fit-for-starlink-mini", pb27:"powerbank-27000mah",
  eb3a:"bluetti-eb3a-600w-portable-power-station", river3:"ecoflow-river-3-245wh-power-station",
  install:"adaptis_installation", installAway:"starlink-installation-on-site", plates:"metal-plates-starlink",
  subRoam:"roam-unlim-starlink-account-management", subHome:"residential-unlimited-abonplata"
};
const rowsNow = () => [...root.querySelectorAll(".ac__group > .ac__row[data-key]")];
const handleOf = row => {
  const a = row.querySelector(".ac__t"), m = a && (a.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
  try { return m ? decodeURIComponent(m[1]) : ""; } catch (e) { return m ? m[1] : ""; }
};
const propsOf = row => {
  let props = {};
  try { props = JSON.parse(row.dataset.props || "{}") || {}; } catch (err) { props = {}; }
  if (Array.isArray(props)) props = Object.fromEntries(props.filter(x => Array.isArray(x) && x.length === 2));
  return props;
};

/* ---------- навіщо ця позиція ---------- */
/* Один простий рядок з іконкою під назвою товару. Текст залежить від того, для чого збирають кошик:
   для авто чи для дому. Це видно з самого кошика (дах авто на корпусі, живлення від прикурювача, монтаж,
   тариф «Мандрівний» кажуть «авто»; тариф «Домашній» і зарядна станція кажуть «дім»). Якщо ознаки
   суперечать одна одній або їх немає, рядок загальний: нічого не вгадуємо. */
const YI = {
  wifi:'<path d="M2 8.8C7.6 4 16.4 4 22 8.8"/><path d="M5.2 12.3C9 9.2 15 9.2 18.8 12.3"/><path d="M8.5 15.7C10.6 14.1 13.4 14.1 15.5 15.7"/><path d="M12 19.5H12.01"/>',
  magnet:'<path d="M6 3.5v8a6 6 0 0 0 12 0v-8h-4v8a2 2 0 0 1-4 0v-8z"/><path d="M6 7.5h4M14 7.5h4"/>',
  plug:'<path d="M9 2v5M15 2v5"/><path d="M6 7h12v4a6 6 0 0 1-12 0z"/><path d="M12 17v5"/>',
  cable:'<path d="M4 9a4 4 0 0 1 8 0v6a4 4 0 0 0 8 0"/><path d="M2.5 5.5h3v3.5h-3zM18.500 15h3v3.5h-3z"/>',
  battery:'<rect x="2" y="7" width="17" height="10" rx="2.5"/><path d="M22 11v2"/><path d="M6 10.5v3M9.5 10.5v3M13 10.5v3"/>',
  wrench:'<path d="M14.7 6.3a4 4 0 0 0 5 5L11 20a2.100 2.100 0 0 1-3-3z"/><path d="M14.7 6.300 17.500 3.500a4 4 0 0 0-5.200 5.200"/>',
  user:'<circle cx="12" cy="7.5" r="3.5"/><path d="M5 20a7 7 0 0 1 14 0"/>',
  /* 09.10.2026 (власник): тариф «Домашній» з іконкою дому, «Мандрівний» з іконкою авто. Ті самі малюнки, що
     в комплектах на сторінці товару (assets/adaptis-configurator.js, ICONS.home і ICONS.car; car це Lucide, ISC). */
  home:'<path d="M3 10.5L12 3l9 7.5"/><path d="M5 9v11h14V9"/><path d="M10 20v-6h4v6"/>',
  car:'<path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/>',
  shield:'<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.170 1.170 0 0 1 1.520 0C14.510 3.810 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>'
};
const WHY = {};
WHY[HN.mini] = c => ["wifi", c === "car" ? ADL("Інтернет в авто: антена і Wi-Fi в одному корпусі") : c === "home" ? ADL("Інтернет удома: антена і Wi-Fi в одному корпусі") : ADL("Антена і Wi-Fi в одному корпусі")];
WHY[HN.miniX] = () => ["wifi", ADL("Антена надворі, окремий роутер роздає Wi-Fi в приміщенні")];
WHY[HN.miniKit] = c => ["magnet", c === "car" ? ADL("Тримає Starlink на даху авто на магнітах") : c === "home" ? ADL("Корпус на магнітах: Starlink стоїть на кондиціонері за вікном, без свердління") : ADL("Корпус на магнітах для Starlink Mini")];
WHY[HN.psu] = () => ["plug", ADL("Живить Starlink від прикурювача")];
WHY[HN.cc160] = WHY[HN.ccSet] = () => ["plug", ADL("Автозарядка на 160 Вт: 100 Вт для Starlink, ще USB-C і USB по 30 Вт")];
WHY[HN.dc] = () => ["cable", ADL("З'єднує Starlink з портом USB-C або павербанком від 100 Вт")];
WHY[HN.eth] = () => ["cable", ADL("З'єднує Starlink з вашим роутером у приміщенні")];
/* 09.10.2026 (власник): рядок каже, чим річ є, а не одну ситуацію. P2Fit це павербанк на терміналі (10.10: не «батарея»), 27 000 це
   великий павербанк. Час від станції залежить від термінала: Standard 4X приблизно 2 години, Mini і Mini X 5. */
WHY[HN.p2fit] = () => ["battery", ADL("Павербанк на терміналі: приблизно 3 години інтернету без розетки й авто")];
WHY[HN.pb27] = () => ["battery", ADL("Великий павербанк: приблизно 3 години Starlink із заглушеним двигуном")];
WHY[HN.eb3a] = WHY[HN.river3] = (c, hs) => {
  const has = h => (hs || []).indexOf(h) > -1;
  const big = has("starlink-standard-gen3") || has(HN.g3kit), small = has(HN.mini) || has(HN.miniX);
  return ["battery", big && !small ? ADL("Інтернет, коли немає світла: приблизно 2 години") : ADL("Інтернет, коли немає світла: приблизно 5 годин")];
};
WHY[HN.install] = () => ["wrench", ADL("Поставимо корпус і прокладемо живлення в салон")];
WHY[HN.installAway] = () => ["wrench", ADL("Приїдемо до вас, поставимо корпус і прокладемо живлення")];
WHY[HN.subRoam] = () => ["car", ADL("Тариф для авто й поїздок. Акаунт оформимо й оплачуватимемо за вас")];
WHY[HN.subHome] = () => ["home", ADL("Тариф для однієї адреси. Акаунт оформимо й оплачуватимемо за вас")];
WHY[HN.amuletT] = WHY[HN.amuletS] = () => ["shield", ADL("Starlink працює під час повітряних тривог")];
function cartCtx(rows){
  const hs = rows.map(handleOf), has = h => hs.indexOf(h) > -1;
  const roof = rows.some(r => [...r.querySelectorAll(".ac__v")].some(p => /^\s*Дах авто\s*:/.test(p.textContent)));
  const car = roof || [HN.psu, HN.cc160, HN.ccSet, HN.install, HN.installAway, HN.plates, HN.subRoam, HN.p2fit, HN.pb27].some(has);
  /* 09.10.2026: корпус з позначкою «Встановлення: на кондиціонер» це дім. */
  const ac = rows.some(r => [...r.querySelectorAll(".ac__v")].some(p => /^\s*Встановлення\s*:.*кондиціонер/.test(p.textContent)));
  const home = ac || [HN.subHome, HN.eb3a, HN.river3].some(has);
  return car && !home ? "car" : home && !car ? "home" : "";
}
function whyLines(){
  const rows = rowsNow(), ctx = cartCtx(rows);
  rows.forEach(row => {
    const f = WHY[handleOf(row)], title = row.querySelector(".ac__t");
    if (!f || !title || row.querySelector(".ac__y")) return;
    const y = f(ctx, rows.map(handleOf)), p = document.createElement("p");
    p.className = "ac__y";
    p.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (YI[y[0]] || "") + '</svg><span></span>';
    p.querySelector("span").textContent = y[1];
    title.insertAdjacentElement("afterend", p);
  });
}

/* ---------- колір корпусу Adaptis ---------- */
/* Кольори це варіанти товару. Показуємо ті, що є в наявності, з тією самою рештою опцій (призначення)
   і без фарбування «в колір авто»: воно коштує інакше і потребує коду фарби. Shopify не вміє міняти
   варіант у позиції, тому додаємо новий варіант з тими самими властивостями і прибираємо старий;
   рядок лишається на своєму місці (swapOrder). */
const CORPUS = [HN.miniKit, HN.g3kit, HN.g2kit, HN.hp];
const HEX = {"Білий":"#E7E8E3", "Чорний":"#1F2220", "Сірий":"#7D827C", "Олива":"#4A5335",
  "White":"#E7E8E3", "Black":"#1F2220", "Grey":"#7D827C", "Gray":"#7D827C", "Olive":"#4A5335",
  "Biały":"#E7E8E3", "Czarny":"#1F2220", "Szary":"#7D827C", "Oliwkowy":"#4A5335"};
const CUSTOM_RE = /колір авто|car colou?r|kolor auta|kolorze auta/i;
const COLOR_RE = /Колір|Colou?r|Kolor/i;
const prodCache = {};
const prodOf = h => prodCache[h] || (prodCache[h] = fetch(cartRoot() + "products/" + encodeURIComponent(h) + ".js", {headers:{Accept:"application/json"}})
  .then(r => r.ok ? r.json() : null).catch(() => null));
function colorRows(){
  rowsNow().forEach(row => {
    const h = handleOf(row);
    if (CORPUS.indexOf(h) < 0 || row.querySelector(".ac__cl")) return;
    prodOf(h).then(p => {
      if (!p || !row.isConnected || row.querySelector(".ac__cl")) return;
      const ci = (p.options || []).findIndex(o => COLOR_RE.test(o.name || o));
      const cur = (p.variants || []).find(v => v.id === +row.dataset.variant);
      if (ci < 0 || !cur || CUSTOM_RE.test(cur.options[ci])) return;
      const list = p.variants.filter(v => v.available && !CUSTOM_RE.test(v.options[ci]) && v.options.every((x, i) => i === ci || x === cur.options[i]));
      if (list.length < 2) return;
      const box = document.createElement("div");
      box.className = "ac__cl";
      box.setAttribute("role", "group");
      box.setAttribute("aria-label", ADL("Колір корпусу"));
      const lb = document.createElement("span");
      lb.className = "ac__cll";
      lb.textContent = ADL("Колір корпусу");
      box.appendChild(lb);
      list.forEach(v => {
        const b = document.createElement("button"), name = v.options[ci];
        b.type = "button";
        b.className = "ac__sw";
        b.title = name;
        b.setAttribute("aria-label", name);
        b.setAttribute("aria-pressed", String(v.id === cur.id));
        if (HEX[name]) b.style.setProperty("--sw", HEX[name]); else { b.classList.add("ac__sw--t"); b.textContent = name; }
        b.addEventListener("click", () => { if (v.id !== cur.id) swapVariant(row, v.id, name); });
        box.appendChild(b);
      });
      const before = row.querySelector(".ac__tg") || row.querySelector(".ac__qty");
      if (before) before.insertAdjacentElement("beforebegin", box);
    });
  });
}
function swapVariant(row, id, colorName){
  if (busy) return;
  busy = true;
  row.classList.add("is-busy");
  const json = {"Content-Type":"application/json", Accept:"application/json"};
  const post = (u, body) => fetch(cartRoot() + u, {method:"POST", headers:json, body:JSON.stringify(body)})
    .then(r => { if (!r.ok) throw new Error(u); return r.json(); });
  const qs = row.querySelector(".ac__qty .qty span");
  const qty = +row.dataset.qty || (qs && parseInt(qs.textContent, 10)) || 1;
  const props = propsOf(row);
  /* властивість «Колір» на позиції має казати те саме, що й варіант; код фарби тут не трапляється */
  Object.keys(props).forEach(k => { if (COLOR_RE.test(k) && !/Код/.test(k)) props[k] = colorName; });
  const item = Object.assign({id:id, quantity:qty}, Object.keys(props).length ? {properties:props} : {});
  post("cart/add.js", {items:[item]})
    .then(added => {
      const got = (added && added.items) || [];
      if (got[0] && got[0].key) swapOrder([[row.dataset.key, got[0].key]]);
      const updates = {};
      updates[row.dataset.key] = 0;
      return post("cart/update.js", {updates:updates, sections:[sectionId], sections_url:location.pathname});
    })
    .then(c => {
      announce(c);
      const h = c.sections && c.sections[sectionId];
      return h && applyHtml(h) ? null : repaint();
    })
    .catch(() => location.reload())
    .then(() => { busy = false; });
}

/* ---------- «Разом із цим купують» ---------- */
/* Ті самі картки й правила, що у вікні «Додано в кошик» (AdaptisRecsCore в adaptis-configurator.js):
   що радити, у якій кількості і з яким поясненням, рахується за всім кошиком. Скрипт вікна довантажуємо
   тут так само, як це робить швидка покупка. Блок переживає перемальовування кошика: вузол той самий. */
let recsHost = null, popLoad = null;
function withPop(){
  if (window.AdaptisCartPop && window.AdaptisCartPop.recsInto) return Promise.resolve(window.AdaptisCartPop);
  const A = window.ADAPTIS_POP_ASSETS;
  if (!A || !A.js) return Promise.reject(new Error("no pop assets"));
  return popLoad || (popLoad = new Promise((res, rej) => {
    const sc = document.createElement("script");
    sc.src = A.js;
    sc.onload = () => window.AdaptisCartPop && window.AdaptisCartPop.recsInto ? res(window.AdaptisCartPop) : rej(new Error("old pop"));
    sc.onerror = rej;
    document.head.appendChild(sc);
  }));
}
function mountRecs(){
  const items = root.querySelector(".ac__items");
  if (!items || !rowsNow().length){ if (recsHost) recsHost.remove(); return; }
  if (!recsHost){
    recsHost = document.createElement("section");
    recsHost.className = "ac__recs";
  }
  if (recsHost.parentNode !== items) items.appendChild(recsHost);
  withPop().then(P => P.recsInto(recsHost, {purpose:() => root.querySelector("[data-def-line]:checked") ? "defense" : "civil"}))
    .then(() => { recsHost.hidden = !recsHost.querySelector(".cpop__rc"); })
    .catch(() => { if (recsHost) recsHost.hidden = true; });
}
function enhance(){
  try { whyLines(); colorRows(); mountRecs(); } catch (e) {}
}
/* Кошик змінили не звідси (картка рекомендацій, вікно швидкої покупки): перемальовуємо. */
document.addEventListener("cart:update", e => {
  const d = (e && e.detail) || {};
  if (d.sourceId === "adaptis-cart" || busy) return;
  repaint();
});
enhance();
})();
